import { render, staticRenderFns } from "./FluffyNavigation.vue?vue&type=template&id=3af19cde&scoped=true&"
import script from "./FluffyNavigation.vue?vue&type=script&lang=js&"
export * from "./FluffyNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af19cde",
  null
  
)

export default component.exports